import React from "react";
import autoBind from "react-autobind";
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button";
import noty from "../../../lib/noty";
import Field from "../../../components/Field";
import FieldSelect from "../../../components/FieldSelect";
import {pointInstructions} from "../../../strings/en-us/text";
import {InstructionsContainer} from "../../../components/Instructions";
import {PanelContainer, Panel} from "../../../components/Panel";
import {MarkerPanel, withMarkerPanel, MarkerPanelMarkers} from "../../../components/MarkerPanel";
import {MapPortal} from "../../../components/Map";
import MapEditMarker from "../MapEditMarker";

class EditMarker extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      panelOpen: true,
      fetching: true,
      touched: false,
      infographics: [],
      marker: this.props.marker
    };
  }

  async componentDidMount() {
    let infographics = await this.props.marker.infographics();
    this.setState({fetching: false, infographics});
  }

  handlePanelToggle() {
    this.setState({panelOpen: !this.state.panelOpen});
  }

  handleChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      marker: this.state.marker.setIn(path, value)
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const {marker} = this.state;
    this.setState({fetching: true});
    marker
      .patch()
      .then(patched => {
        this.setState({fetching: false, touched: false});
        noty.success("Marker updated.");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  }

  handleRemove() {
    const {marker} = this.state;
    noty.confirm(`Are you sure you want to delete "${marker.name}"`, {
      onOk: () => {
        this.setState({fetching: true});
        marker
          .remove()
          .then(removed => {
            noty.success("Marker removed.");
          })
          .catch(err => {
            this.setState({fetching: false});
            noty.errors(err);
          });
      }
    });
  }

  render() {
    const {floor, match, markerFilter, toggleAllMarkerFilter, toggleMarkerFilter} = this.props;
    const {marker, fetching, touched, infographics} = this.state;
    const markers = floor.markers();
    let infographicCount = `${infographics.length} infographics`;

    return (
      <div>
        <PanelContainer width={475} open={this.state.panelOpen} onToggle={this.handlePanelToggle}>
          <Panel
            onSaveClick={this.handleSubmit}
            saveTitle="Save Marker"
            onDeleteClick={this.handleRemove}
            fetching={fetching}
            touched={touched}
            touchedMessage="Are you sure that you want to leave? This marker has unsaved changes.">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <FieldSelect
                    name="type_id"
                    value={marker.type_id}
                    onChange={this.handleChange}
                    label="Marker Type"
                    options={marker.selectOptions()}
                    disabled={fetching}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <Field
                    name="name"
                    value={marker.name}
                    onChange={this.handleChange}
                    label="Marker Name"
                    disabled={fetching}
                  />
                </div>
              </div>
              <InstructionsContainer>{pointInstructions}</InstructionsContainer>
            </div>
          </Panel>
          <Panel>
            <div className="row middle-xs">
              <div className="col-xs-4">
                <p className="text-muted">{infographicCount}</p>
              </div>
              <div className="col-xs-8">
                <Link to={`${this.props.match.url}/infographics`}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{float: "right"}}
                    onClick={this.openInfographicEditor}
                    disabled={fetching}>
                    Open Editor
                  </Button>
                </Link>
              </div>
            </div>
          </Panel>
          <MarkerPanel
            match={match}
            floor={floor}
            toggleMarkerFilter={toggleMarkerFilter}
            toggleAllMarkerFilter={toggleAllMarkerFilter}
            markerFilter={markerFilter}
            disabled={fetching}
          />
        </PanelContainer>
        <MapPortal center={this.props.defaultCenter}>
          <MapEditMarker
            marker={marker}
            floor={floor}
            onMarkerLocationChange={coords =>
              this.handleChange({
                name: "geo.coordinates",
                value: coords
              })
            }
          />
          <MarkerPanelMarkers match={match} markers={markers} markerFilter={markerFilter} floor={floor} />
        </MapPortal>
      </div>
    );
  }
}

export default withMarkerPanel(EditMarker);



// WEBPACK FOOTER //
// ./src/pages/Facility/EditMarker/index.jsx